import React from 'react';
import PropTypes from 'prop-types';

import { IconComponent } from '../../atoms/icons/iconComponent';

const headerItem = (props) => {
  const {
    className, icon, title, subtitle,
  } = props;

  return (
    <div
      className={`flex justify-center text-gray-600 text-sm items-start ${className || ''}`}
    >
      {icon && <IconComponent icon={icon} className="text-lg"/>}
      <div className="px-1 text-gray-800">
      {title}
      {subtitle && <span className="ml-1 text-xs text-gray-500 self-center whitespace-nowrap">({subtitle})</span>}
      </div>
    </div>
  );
};

headerItem.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

headerItem.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default headerItem;
